import * as React from "react";
import { AppShape, LoanPrograms } from "@eave/shared/types/api";

import { formatPercent } from "@eave/shared/utils/percent";
import { formatCurrency } from "@eave/shared/utils/currency";
import { verticalHeaderTRUSTable } from "./shared";

const styles = require("./styles.module.scss");

export const getLoanType = (program): string => {
  // Return strings taken from the spreadsheet in T1351
  const armType = [
    LoanPrograms.FIVE_ARM,
    LoanPrograms.SEVEN_ARM,
    LoanPrograms.TEN_ARM,
    LoanPrograms.FIVE_SIX_THIRTY_DAY_SOFR_ARM,
    LoanPrograms.SEVEN_SIX_THIRTY_DAY_SOFR_ARM,
    LoanPrograms.TEN_SIX_THIRTY_DAY_SOFR_ARM,
  ];
  const fixedType = [LoanPrograms.THIRTY_YEAR];
  if (armType.includes(program)) {
    return "ARM - Fixed 5 Years or More";
  }
  if (fixedType.includes(program)) {
    return "Fixed";
  }
  throw new Error("Loan type not supported");
};

interface Props {
  app: AppShape;
}

const LoanInfo: React.FC<Props> = ({ app }: Props) => {
  const loanAmount = Number(
    (app && app.computed_properties && app.computed_properties.loan_amount) || 0,
  );
  const table1 = [
    { label: "Loan Purpose", value: "Purchase" },
    { label: "Loan Amount", value: formatCurrency(loanAmount, 2, 2) },
    { label: "Interest Rate", value: formatPercent(app.decision.effective_rate) },
    { label: "Amortization Term", value: "360 months" },
    { label: "Loan Type", value: getLoanType(app.selected_loan_program as LoanPrograms) },
    { label: "Proposed PITIA", value: formatCurrency(app.decision.total_housing_expenses, 2, 2) },
    { label: "Debt-To-Income", value: formatPercent(+app.decision.dti * 100, 2) },
  ];
  const table2 = [
    { label: "Temporary Buydown", value: "No Buydown" },
    { label: "Bi-Weekly Payment", value: "No" },
    { label: "Third-Party Originated Loan", value: "No" },
    { label: "LTV", value: formatPercent(app.computed_properties.ltv, 2) },
    { label: "CLTV", value: "N/A" },
    { label: "HCLTV", value: "N/A" },
  ];

  return (
    <>
      <h2>Loan Information</h2>
      <div className={styles.table}>
        {verticalHeaderTRUSTable(table1)}
        {verticalHeaderTRUSTable(table2)}
      </div>
    </>
  );
};

export default LoanInfo;
